import { defineElement, FC, onDidLoad, useElement, useListen } from '@atomify/hooks';
import { debounce } from '@bpd-library/utilities';
import { elements } from '@source/utilities/dom';

const CTA_ACTIVE_CLASS = 'house-characteristics-cta-bar--is-active';
const CTA_BODY_CLASS = 'has--house-characteristics-cta-bar';

const BPDHouseCharacteristicsCtaBar: FC = ({ element }) => {
    const characteristicsSection = useElement<HTMLElement>('[js-hook-characteristics-section]', {
        root: document,
    });

    useListen(window, 'scroll', () => {
        debounce(() => {
            setActiveClass();
        }, 200)();
    });

    onDidLoad(() => {
        setBodyClass();
        setActiveClass();
    });

    function setBodyClass() {
        elements.body.classList.add(CTA_BODY_CLASS);
    }

    function setActiveClass() {
        if (!characteristicsSection.current) return;

        const action =
            window.pageYOffset >
            characteristicsSection.current.offsetTop + characteristicsSection.current.clientHeight
                ? 'add'
                : 'remove';
        element.classList[action](CTA_ACTIVE_CLASS);

        elements.body.classList[action](CTA_ACTIVE_CLASS);
    }
};

defineElement('bpd-house-characteristics-cta-bar', BPDHouseCharacteristicsCtaBar);
